import Utility from '../classes/Utility';
import AdUnitSize from '../classes/AdUnitSize';

class AdUnitPlaceholder {
  static auPInstance = null;
  static PLACEHOLDER_SIZE_MAPPING = [
    {
      matcher: /.*x$/,
      name: 'Ad slots with X',
      mapping: {
        m: ['100%', 70],
        t: ['100%', 70],
        dt: ['100%', 70]
      }
    },
    {
      matcher: /^np.*[^x]/,
      name: 'NP without X',
      mapping: {
        m: [300, 250],
        t: [300, 250],
        dt: [300, 250]
      }
    },
    {
      matcher: /^fp.*[^x]/,
      name: 'FP without X',
      mapping: {
        m: [300, 250],
        t: [728, 90],
        dt: [728, 90]
      }
    },
    {
      matcher: /^wp.*[^x]/,
      name: 'WP without X',
      mapping: {
        m: [300, 250],
        t: [728, 90],
        dt: [728, 90]
      }
    },
    {
      matcher: /^o.*/,
      name: 'All O',
      mapping: {
        m: [300, 250],
        t: [640, 480],
        dt: [640, 480]
      }
    }
  ]

  static instance() {
    AdUnitPlaceholder.auPInstance = AdUnitPlaceholder.auPInstance || new AdUnitPlaceholder();

    return AdUnitPlaceholder.auPInstance;
  }

  render = ({isNative, adUnit, devices, parentNode, unitType, sizes}) => {
    const container = document.createElement('div');
    container.classList.add('t-flex', 't-flex-col', 't-p-3', 't-border', 't-border-mitre-gray-250', 't-overflow-auto', 't-mx-auto', 't-shadow-outline-md', 't-text-xs');

    const adUnitText = document.createElement('p');
    adUnitText.innerHTML = `Unit Path: <span class="t-font-bold">${adUnit}</span>`;
    container.appendChild(adUnitText);

    const devicesContainer = document.createElement('div');
    const devicesText = document.createElement('p');
    devicesText.innerHTML = `Devices: <span class="t-font-bold">${devices ? devices : ''}</span>`;
    devicesContainer.appendChild(devicesText);

    ['m', 't', 'dt'].forEach(device => {
      const deviceSizes = AdUnitSize.getSizeByDevice(unitType, device)
      if (deviceSizes.length > 0) {
        const sizeText = document.createElement('p');
        sizeText.textContent = `${device}: `;
        deviceSizes.forEach(size => {
          let text = ''
          if (typeof size === 'string') {
            text = size;
          } else {
            const [w, h] = size;
            text = `[${w} x ${h}] `
          }
          sizeText.textContent = sizeText.textContent + text;
        })
        devicesContainer.appendChild(sizeText);
      }
    })

    container.appendChild(devicesContainer);

    const nativeText = document.createElement('p')
    if (isNative) {
      container.classList.add('t-bg-mitre-purple-100', 't-text-black');
    }
    nativeText.innerHTML = `Native: <span class="t-font-bold">${isNative}</span>`;
    container.appendChild(nativeText);

    const sizesText = document.createElement('div');
    const sizeTitle = document.createElement('p');
    sizeTitle.textContent = 'Sizes:';
    sizesText.appendChild(sizeTitle);

    sizes.forEach(size => {
      const sizeText = document.createElement('a');
      if (typeof size === 'string') {
        sizeText.textContent = size;
      } else {
        sizeText.href = '#';
        const [w, h] = size;
        sizeText.textContent = `${w} x ${h}`;
        sizeText.addEventListener('click', e => {
          e.preventDefault();
          container.style.width = typeof w === 'string' ? w : `${w}px`;
          container.style.height = typeof h === 'string' ? h : `${h}px`;
          parentNode.style.width = typeof w === 'string' ? w : `${w}px`;
          parentNode.style.height = typeof h === 'string' ? h : `${h}px`;
          sizesText.querySelectorAll('a').forEach(el => {
            el.classList.remove('t-font-bold')
          })
          sizeText.classList.add('t-font-bold');
        });
      }
      sizeText.classList.add('hover:t-no-underline', 'hover:t-text-mitre-gray-300', 't-block')
      sizesText.appendChild(sizeText);
    });
    AdUnitPlaceholder.PLACEHOLDER_SIZE_MAPPING.some(mappingType => {
      if (mappingType.matcher.test(unitType)) {
        const [w, h] = mappingType.mapping[Utility.getDeviceType()];
        container.style.width = typeof w === 'string' ? w : `${w}px`;
        container.style.height = typeof h === 'string' ? h : `${h}px`;
        parentNode.style.width = typeof w === 'string' ? w : `${w}px`;
        parentNode.style.height = typeof h === 'string' ? h : `${h}px`;
        parentNode.classList.add('t-overflow-auto');
        return true;
      }
      return false;
    });
    container.appendChild(sizesText);

    const targettingText = document.createElement('div');
    const targettingTitle = document.createElement('p');
    targettingTitle.textContent = 'Targetting:';
    targettingText.appendChild(targettingTitle)
    window.EventManager.on('google_ad_loaded', () => {
      const targettingKeys = googletag.pubads().getTargetingKeys();
      targettingKeys.forEach(targetKey => {
        const targetValue = googletag.pubads().getTargeting(targetKey);
        const pageTargetText = document.createElement('p');
        pageTargetText.textContent = `${targetKey}: ${targetValue}`;
        targettingText.appendChild(pageTargetText);
      })
      container.appendChild(targettingText);
    })

    this.__forceInterstitialsToShow();

    parentNode.appendChild(container);
  }

  __forceInterstitialsToShow = () => {
    window.EventManager.emit('modal_state', {
      showState: 'true',
      domId: 'sticky_footer'
    })
    window.EventManager.emit('modal_state', {
      showState: 'true',
      domId: 'interstitial'
    })
    window.EventManager.emit('modal_state', {
      showState: 'true',
      domId: 'welcome-interstitial'
    })
    const showExitInterstitial = e => {
      if (!e.relatedTarget && !e.toElement) {
        window.EventManager.emit('modal_state', {
          showState: 'true',
          domId: 'exit-interstitial'
        })
        document.body.removeEventListener('mouseleave', showExitInterstitial);
      }
    }
    document.body.addEventListener('mouseleave', showExitInterstitial);
  }

  showPlaceholder() {
    const placeholderParam = Utility.getUrlParam('placeholder');
    const placeholderCookie = Utility.getCookie('placeholder');
    if (placeholderParam === 'true') {
      Utility.setCookieWithExpiration('placeholder', 'true', 'session');
      return true;
    } else if (placeholderParam === 'false') {
      Utility.setCookieWithExpiration('placeholder', 'false', 'session');
    } else {
      // Use cookie value
      if (placeholderCookie === 'true') {
        return true;
      }
    }
    return false;
  }


}

export default AdUnitPlaceholder.instance();
